export const RETAILER_SERVICES = {
  DELIVERY: 'delivery',
  COUNT: 'count',
  COLLECTION: 'collection',
  PROVISIONAL: 'provisional',
  CANCELLED: 'cancelled'
}
